import { decodeMeshSnapshot } from "../domain/schema";
import type { MeshSnapshot } from "../domain/mesh";
import { createMockSnapshot } from "../mocks/mesh";
import type { DataSource } from "../application/types";
import { withoutOperationalData } from "../catalog/operationalCatalog";

export type ApiResult<T> = {
  data: T;
  source: DataSource;
  error: string | null;
};

async function requestJson(url: string, signal?: AbortSignal): Promise<unknown> {
  const response = await fetch(url, { signal, headers: { Accept: "application/json" } });
  if (!response.ok) throw new Error(`${url} returned HTTP ${response.status}`);
  return response.json();
}

export async function loadSnapshot(signal?: AbortSignal): Promise<ApiResult<MeshSnapshot>> {
  try {
    const data = decodeMeshSnapshot(await requestJson("/api/mesh/snapshot-v3", signal));
    return { data, source: "live", error: null };
  } catch (error) {
    if (signal?.aborted) throw error;
    const message = error instanceof Error ? error.message : "Unknown snapshot error";
    console.warn("K·NEXUS snapshot fallback:", message);
    return { data: withoutOperationalData(createMockSnapshot()), source: "fallback", error: message };
  }
}
